if( $('#special-page.grow-together').length ){
  function logoHover(target, path){
  referrer = target.attr('data-referrer');
  url = $('#special-page.grow-together').attr('data-get-blog-info') + '/assets/svg/grow-together/' + path + '/' + referrer + '.svg';
  target.find('.logo').css('background-image', 'url("' + url + '")');
  }
  $(function(){
    $('#grow-together-eligibility article a').on('mouseover', function(){
      logoHover($(this), 'hover');
    });
    $('#grow-together-eligibility article a').on('mouseout', function(){
      logoHover($(this), 'grey');
    });
  });
}
